// extracted by mini-css-extract-plugin
module.exports = {"label":"_23gFm"};